import React from "react";

export default ({children}) => (
  <div className="test_layout">
    {children}
  </div>
);